import moment from 'moment';

export default async () => {
  window.moment = moment;
};
